import { render } from "./FAQ.vue?vue&type=template&id=2018e188&scoped=true&ts=true"
import script from "./FAQ.ts?vue&type=script&lang=ts&external"
export * from "./FAQ.ts?vue&type=script&lang=ts&external"

import "./FAQ.vue?vue&type=style&index=0&id=2018e188&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2018e188"]])

export default __exports__